import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "slug"]
  static values = { auto: { type: Boolean, default: true } }

  generate() {
    if (!this.autoValue) return
    if (!this.hasSlugTarget) return
    const slug = this.sourceTarget.value
      .toLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "")
    this.slugTarget.value = slug
  }

  manualEdit() {
    this.autoValue = false
  }
}
